/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

angular.module("prices")
  // regexp pattern for price value fields
  .constant("pricePattern", /^\d+(\.\d{1,2})?$/)
  // operations which allow to reproduce in price lines for domains group
  .constant("activeDomainsOperations", ['create', 'renew', 'transfer', 'trade'])
  // operations which allow to reproduce in price line for all rest groups
  .constant("activeOperations", ['create', 'renew'])
  /**
   * @ngdoc controller
   * @name priceLineCtrl
   * @requires $scope, $aside, $modalInstance, $filter, $location, b17Service, auth, userCache
   *
   * @description
   * Price Line Controller
   */
  .controller("priceLineCtrl", function (
    $scope, $aside, $modalInstance, $filter, $location, b17Service, auth,
    userCache, currencyMap, priceLine, pricePattern,
    activeDomainsOperations, activeOperations ) {

    var isApprove = false;

    $scope.location = $location.path();

    // init error and info messages
    $scope.errorMessage = null;
    $scope.infoMessage = null;

    // default close button text
    $scope.closeMessage = 'Cancel';

    // init currency map for the currency selector
    $scope.currencyMap = currencyMap;

    // use date and time 00:00:00
    $scope.currentDate = new Date();
    $scope.datetime = new Date(
      $scope.currentDate.getUTCFullYear(),
      $scope.currentDate.getUTCMonth(),
      $scope.currentDate.getUTCDate()
    );
    $scope.minDate = angular.copy($scope.datetime);

    // add form patterns
    $scope.pricePattern = pricePattern;

    // type of operations for price line
    $scope.operations = {};

    // new price line for editing
    $scope.newPrice = {};

    // controller scope data used in view
    $scope.data = {};
    $scope.data.history = [];
    // if release history can be seen
    $scope.history = false;

    // init original price line
    $scope.data.priceLine = priceLine;
    $scope.data.priceLine.prime = priceLine.cost + priceLine.extras;

    // init new price line by original price line
    $scope.newPrice = angular.copy($scope.data.priceLine);

    // create new release price version
    $scope.data.priceVersion = new b17Service.versions();
    $scope.data.priceVersion.release = true;
    $scope.data.priceVersion.edition = priceLine.version;
    $scope.data.priceVersion.description = '';
    $scope.data.priceVersion.group = priceLine.group;
    $scope.data.priceVersion.product = priceLine.product;

    // check if price lines history does exist
    checkReleases();

    // -------------
    // GET REST DATA
    // -------------

    // Get b17 config
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {

        $scope.data.config = config.data.data.results[0];

        // add operations which can be reproduced
        angular.forEach($scope.data.config.operations, function(value) {
          // if domains group and non-reproducable operation - show only this operation
          if ($scope.data.priceLine.group === 'domains' &&
            (activeDomainsOperations.indexOf($scope.data.priceLine.operation) === -1 ||
            $scope.data.priceLine.article !== 'default')) {
            if ($scope.data.priceLine.operation === value) {
              $scope.operations[value] = $scope.data.priceLine.operation === value;
            }
          } else {
            // if reproducable operations
            if ($scope.data.priceLine.group === 'domains' &&
              activeDomainsOperations.indexOf(value) != -1 ||
              $scope.data.priceLine.group !== 'domains' &&
              activeOperations.indexOf(value) != -1 ||
              $scope.data.priceLine.operation === value) {

              $scope.operations[value] = $scope.data.priceLine.operation === value;
            }
          }
        });

      } else {
        checkErrorCodeMessage();
      }
    });

    // get regular price line
    b17Service.getPrice(
      {
        cache: false,
        group: priceLine.group,
        product: priceLine.product,
        provider: priceLine.provider,
        article: priceLine.article,
        operation: priceLine.operation,
        quantity: priceLine.quantity,
        version: priceLine.version,
      }).then(function (prices) {
        if (prices.data && prices.data.data) {
          $scope.data.priceLine = prices.data.data.results[0];
          $scope.data.priceLine.prime = parseFloat(
            ($scope.data.priceLine.cost + $scope.data.priceLine.extras).toFixed(2)
          );
          $scope.newPrice = angular.copy($scope.data.priceLine);
        } else {
            checkErrorCodeMessage();
        }
      }
    );

    // Open Date Picker
    $scope.openDatePicker = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    // setup initial date picker options
    $scope.dateOptions = {
      startingDay: 1,
      showWeeks: false,
    };

    // watch $scope.datetime and prepare it to save
    $scope.$watch('datetime', function(newValue) {
      $scope.data.priceVersion.date = {
        from: $filter("date")(newValue, "yyyy-MM-dd"),
        start: $filter("date")(newValue, "HH:mm:00"),
      };
    });

    // save price version and price without approving
    $scope.save = function () {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      isApprove = false;
      $scope.data.priceVersion.active = false;
      $scope.data.priceVersion.used = false;
      if (!isValidForm()) {
        return;
      }
      // Reset release number
      $scope.data.priceVersion.number = null;
      // create new price version with release mode
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          $scope.data.priceVersion.$create({token: auth.getToken()}, updatePriceLine);
        }
      });
    };

    // save price version and price with approving
    $scope.approve = function () {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      isApprove = true;
      $scope.data.priceVersion.active = false;
      $scope.data.priceVersion.used = false;
      if (!isValidForm()) {
        return;
      }
      // Reset release number
      $scope.data.priceVersion.number = null;
      // create new price version with release mode
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          $scope.data.priceVersion.$create({token: auth.getToken()}, updatePriceLine);
        }
      });
    };

    // approve the release which was saved before (from the releases history)
    $scope.approveRelease = function(number) {
      var release = new b17Service.versions();

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      checkLogin().then(function (isLogged) {
        if (isLogged) {
          release.$get({
            number: number,
          }, function(data) {
            if (data.number) {
              if (data.release && !data.active && !data.used) {
                data.active = true;
                data.$save({
                  token: auth.getToken()
                }, function (data) {
                  if (data.number && data.active) {
                    $scope.data.history.forEach(function (item) {
                      if (item.number === number) {
                        item.active = data.active;
                        item.used = data.used;
                        b17Service.getResponse().then(function (response) {
                          if (response.data && response.data.data.success) {
                              renewPriceLine();
                          }
                        });
                      }
                    });
                    $scope.infoMessage = 'The release was successfuly approved';
                    $scope.closeMessage = 'Close';
                  } else {
                    $scope.errorMessage = 'This release was not approved!';
                  }
                });
              } else {
                $scope.errorMessage = 'This release already approved before!';
                $scope.data.history.forEach(function (item) {
                  if (item.number === number) {
                    item.active = true;
                  }
                });
              }
            } else {
              checkErrorCodeMessage();
            }
          });
        }
      });
    };

    // delete the release which was saved before (from the releases history)
    $scope.deleteRelease = function(number) {
      var release = new b17Service.versions();

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      checkLogin().then(function (isLogged) {
        if (isLogged) {
          release.$get({
            number: number,
          }, function(data) {
            if (data.number) {
              if (data.release && !data.used) {
                var prices = new b17Service.prices();
                prices.$delete({
                  token: auth.getToken(),
                  version: number
                }, function (response) {
                  if (response.data && response.data.success) {
                    data.$delete({
                      token: auth.getToken()
                    }, function (response) {
                      if (response.data && response.data.success) {
                        $scope.data.history.forEach(function (item, index) {
                          if (item.number === number) {
                            $scope.data.history.splice(index, 1);
                          }
                        });
                        $scope.infoMessage = 'The release was successfuly deleted';
                        $scope.closeMessage = 'Close';
                      } else {
                        checkErrorCodeMessage();
                      }
                    });
                  }
                });
              } else {
                $scope.errorMessage = 'This release already applied and could not be deleted!';
                $scope.data.history.forEach(function (item) {
                  if (item.number === number) {
                    item.active = true;
                  }
                });
              }
            } else {
              checkErrorCodeMessage();
            }
          });
        }
      });
    };

    // close or cancel changes (do not apply changes)
    $scope.closeOrCancel = function () {
      // if already saved - close window
      if ($scope.closeMessage === 'Close') {
        if (isApprove) {
          $modalInstance.close('approve');
        } else {
          $modalInstance.close('save');
        }
      } else {
        $modalInstance.dismiss('cancel');
      }
    };

    // make changes in dependency of prime/cost
    $scope.applyPrimeCost = function() {
      $scope.newPrice.extras = parseFloat(($scope.newPrice.prime - $scope.newPrice.cost).toFixed(2));
    };

    // copy price from release to current
    $scope.copyPrice = function(release) {
      $scope.data.config.tiers.forEach( function(tier) {
        $scope.newPrice.tier[tier] = release.tier[tier];
      });
      $scope.newPrice.prime = parseFloat((release.cost + release.extras).toFixed(2));
      $scope.newPrice.cost = release.cost;
      $scope.newPrice.extras = release.extras;
    };

    // fill price data by zero
    $scope.clearPrice = function() {
      $scope.data.config.tiers.forEach( function(tier) {
        $scope.newPrice.tier[tier] = 0;
      });
      $scope.newPrice.prime = 0;
      $scope.newPrice.cost = 0;
      $scope.newPrice.extras = 0;
    };

    $scope.selectCurrency = function(currency) {
      $scope.newPrice.currency = currency;
    };

    // clear error message
    $scope.dismissError = function() {
      $scope.errorMessage = null;
    };

    // clear info message
    $scope.dismissInfo = function() {
      $scope.infoMessage = null;
    };

    // check if form has valid values
    function isValidForm() {
      $scope.errorMessage = null;
      if ($scope.priceForm.$invalid) {
        if ($scope.priceForm.$error.required) {
          $scope.errorMessage = 'Please complete all required fields.';
        } else {
          if ($scope.priceForm.$error.pattern) {
            $scope.errorMessage = 'Please complete all fields correctly.';
          } else {
            if ($scope.priceForm.$error.date) {
              $scope.errorMessage = 'Invalid date/time format.';
            }
          }
        }
        return false;
      }

      return true;
    }

    // check login
    function checkLogin() {
      return auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          return true;
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
          return false;
        }
      });   
    }

    // get all existing releases
    function checkReleases() {
      b17Service.getReleases({
        cache: false,
        edition: priceLine.version,
        group: priceLine.group,
        product: priceLine.product,
      }).then(function (releases) {
        if (releases.data && releases.data.data) {
          if (releases.data.data.total > 0) {
            $scope.data.history = [];
            releases.data.data.results.forEach(checkRelease);
          }
        } else {
            checkErrorCodeMessage();
        }
      });
    }

    // get release history if it does exist
    function checkRelease(release) {
      if (release.used) {
        return;
      }
      b17Service.getPrices({
        cache: false,
        group: priceLine.group,
        product: priceLine.product,
        provider: priceLine.provider,
        version: release.number,
        legacy: 'true',
        regular: 'true',
      }).then(function (prices) {
        if (prices.data && prices.data.data) {
          if (prices.data.data.total > 0) {
            var operations = [];
            var item = angular.copy(release);
            prices.data.data.results.forEach( function(price) {
              operations.push(price.operation);
              if (price.operation === priceLine.operation &&
                price.article === priceLine.article &&
                price.quantity === priceLine.quantity
              ) {
                item.price = price;
              }
            });
            if (item.price) {
              item.operations = operations;
              item.description = (release.description ? release.description + ', ': '') +
                'last modified at ' + release.revisionDate.substring(0,10) +
                ' ' + release.revisionDate.substring(11,19) + ' CET';               
              item.approveInfo = (release.active && release.approvedBy ? 'approved at ' + 
                  release.approvedAt.substring(0,10) + ' ' + release.approvedAt.substring(11,19) + ' CET': '');
              $scope.data.history.push(item);
              $scope.data.history.sort(sortReleases);
            }
          }
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    // sort releases by date of release
    function sortReleases(left, right) {
      if (left.date.from > right.date.from) {
        return 1;
      }
      if (left.date.from < right.date.from) {
        return -1;
      }
      if (left.date.start > right.date.start) {
        return 1;
      }
      if (left.date.start < right.date.start) {
        return -1;
      }
      if (left.number > right.number) {
        return 1;
      }
      if (left.number < right.number) {
        return -1;
      }
      return 0;
    }

    // update Price Line and check errors
    function updatePriceLine(release) {

      if (!release.number) {
        checkErrorCodeMessage();
        return;
      }

      var version = release.number;
      var query = {
          cache: false,
          legacy: 'true',
          regular: 'true',
          version: priceLine.version,
          group: priceLine.group,
          product: priceLine.product,
        };

      // Specify only one provider
      if ($scope.newPrice.provider !== null) {
        query.provider = $scope.newPrice.provider;
      }

      // get prices which used to choose matched price lines
      b17Service.getPrices(query).then(function(prices) {
        if (prices.data && prices.data.data) {

          // the results which match with query
          var matchingResults = [];

          // choose all matched items
          prices.data.data.results.forEach( function(item) {
            if ($scope.newPrice.article === item.article &&
              $scope.newPrice.quantity === item.quantity &&
              $scope.operations[item.operation]) {
              matchingResults.push(item);
            }
          });

          // count of operations
          var operationsCount = matchingResults.length + 1;
          var currentOperation = 1;

          // look up over matched items and make changes for every price line item
          matchingResults.forEach(function (item) {
            // get price item, change price and save it back
            b17Service.price.get({
              group: item.group,
              product: item.product,
              provider: item.provider,
              article: item.article,
              operation: item.operation,
              quantity: item.quantity,
              version: item.version,
            }, function(priceItem) {
              priceItem.version = version;
              priceItem.id = null;
              priceItem.currency = $scope.newPrice.currency;
              $scope.data.config.tiers.forEach( function(tier) {
                priceItem.tier[tier] = parseFloat($scope.newPrice.tier[tier]);
              });

              // allow to change cost and extras if provider only one
              if (priceItem.provider === priceLine.provider) {
                priceItem.cost = parseFloat($scope.newPrice.cost);
                priceItem.extras = parseFloat($scope.newPrice.extras);
              } else {
                // correct extras due to prime changes
                priceItem.extras = parseFloat(($scope.newPrice.prime - priceItem.cost).toFixed(2));
              }

              // save price line and activate corresponding event
              priceItem.$save({
                token: auth.getToken()
              }, function (priceLineData) {
                // check the data was saved correctly
                if(priceLineData.id) {
                  
                  // update count of operations
                  currentOperation++;

                  // if the last operation
                  if (currentOperation === operationsCount) {

                    $scope.infoMessage = 'All changes was successfuly saved';

                    // if is approved activate price version and close price line window
                    if (isApprove) {
                      $scope.data.priceVersion.active = true;
                      $scope.data.priceVersion.$save({
                        token: auth.getToken()
                      }, function(activeVersion) {
                        if (activeVersion.number) {
                          $scope.infoMessage = $scope.infoMessage + ' and approved';
                        }
                      });
                    }
                    b17Service.getResponse().then(function (response) {
                      if (response.data && response.data.data.success) {
                        $scope.closeMessage = 'Close';
                        checkRelease(release);
                      }
                    });
                  }
                } else {
                  checkErrorCodeMessage();
                }
              });
            });
          });
        } else {
          checkErrorCodeMessage();
        }
      },
      function (response) {
          checkErrorCodeMessage();
      });
    }

    // renew price lines after approve/update
    function renewPriceLine() {
      b17Service.getPrice(
        {
          cache: false,
          group: priceLine.group,
          product: priceLine.product,
          provider: priceLine.provider,
          article: priceLine.article,
          operation: priceLine.operation,
          quantity: priceLine.quantity,
        }).then(function (prices) {
          if (prices.data && prices.data.data) {
            $scope.data.priceLine = prices.data.data.results[0];
            $scope.data.priceLine.prime = parseFloat(
              ($scope.data.priceLine.cost + $scope.data.priceLine.extras).toFixed(2)
            );
          } else {
              checkErrorCodeMessage();
          }
        }
      );
    }

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        $scope.errorMessage = 'Error: (' + userCache.get('lastErrorCode') +
          ') ' + userCache.get('lastErrorMessage') + ': ' + userCache.get('lastErrorInfo');
      } else {
        $scope.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

  });

})();
